import styled, { css } from 'styled-components'

import { desktopCSS, mobileAndTabletCSS } from '@measures/responsive'
import { StyledWrapper as AdRingierWrapper } from '@components/Ad/Wrapper'
import RelatedMatchesWrapper from '@components/RelatedMatches/Wrapper'
import TeaserToiWrapper from '@components/TeaserToi/Wrapper'
import TeaserToiCommercialWrapper from '@components/TeaserToiCommercial/Wrapper'

export interface MainFlowWrapperProps {
  hasPartner: boolean
}

const MainFlowWrapper = styled.div<MainFlowWrapperProps>`
  ${({
    theme: {
      spacing: { spacing8, spacing16, spacing32 },
    },
    hasPartner,
  }) => css`
    display: grid;
    width: 100%;

    ${desktopCSS(css`
      grid-column: span 8;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-gap: ${spacing32};
      align-items: flex-start;

      ${TeaserToiCommercialWrapper},
      ${TeaserToiWrapper}, 
      ${AdRingierWrapper}.slot-code-desktop-index_teaser_3,
      ${AdRingierWrapper}.slot-code-desktop-index_teaser_4 {
        grid-column: 1 / -1;
      }

      ${RelatedMatchesWrapper} {
        display: none;
      }
    `)};

    ${mobileAndTabletCSS(css`
      grid-template-columns: minmax(0, 1fr);

      ${TeaserToiCommercialWrapper},
      ${TeaserToiWrapper},
      ${AdRingierWrapper}.slot-code-tablet-index_teaser_3,
      ${AdRingierWrapper}.slot-code-mobile-index_teaser_3,
      ${AdRingierWrapper}.slot-code-tablet-index_teaser_4,
      ${AdRingierWrapper}.slot-code-mobile-index_teaser_4 {
        &:first-child {
          ${!hasPartner &&
          css`
            margin-bottom: ${spacing8};
          `};
        }
      }

      grid-row-gap: ${spacing16};
    `)};
  `}
`

export default MainFlowWrapper
